<template>
    <Head title="Application Received - RentRisk" />

    <div class="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
        <div class="max-w-lg w-full text-center">
            <div class="flex justify-center mb-6">
                <jet-authentication-card-logo-colored />
            </div>
            <div class="bg-white rounded-lg shadow-lg p-8">
                <div class="flex justify-center mb-4">
                    <div class="flex items-center justify-center w-14 h-14 rounded-full bg-green-100">
                        <font-awesome-icon :icon="faCircleCheck" class="text-green-600 text-2xl" />
                    </div>
                </div>
                <h1 class="text-2xl font-bold text-[#2A375E] mb-2">Thank you for your application</h1>
                <p class="text-gray-600 text-sm">
                    This has been sent to the RentRisk team for review.
                </p>
            </div>
            <Link
                :href="route('logout')"
                method="post"
                as="button"
                class="mt-6 inline-flex items-center gap-2 text-sm text-gray-500 hover:text-[#2A375E]"
            >
                <font-awesome-icon :icon="faRightFromBracket" /> Sign out
            </Link>
        </div>
    </div>
</template>

<script setup>
import { Head, Link } from '@inertiajs/vue3'
import JetAuthenticationCardLogoColored from '@/Jetstream/AuthenticationCardLogoColored.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons'
import { faRightFromBracket } from '@fortawesome/pro-light-svg-icons'
</script>
